import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSyncTagsQuery } from '@dashboard/api/syncMonitor';
import classes from './TagBadge.module.scss';

export default function TagBadge({ tag }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });

  // Same cached request as the filter chips: one call for the whole page.
  const { data } = useSyncTagsQuery();
  const rules = data?.data?.rules ?? {};
  const hint = t(`tagHint_${tag}`, {
    minDays: rules.fresh_min_days ?? 5,
    maxAgeDays: rules.fresh_max_age_days ?? 365,
    activeMinDays: rules.active_min_days ?? 5,
    newMaxDays: rules.new_max_days ?? 90,
    pfFreshFrom: rules.pf_fresh_from ?? '',
    pfSemifreshDays: rules.pf_semifresh_days ?? 90,
    defaultValue: '',
  });

  return (
    <span
      className={`${classes.badge} ${classes[`tag_${tag}`] || ''}`}
      title={hint || undefined}
    >
      {t(`tag_${tag}`, tag)}
    </span>
  );
}

TagBadge.propTypes = {
  tag: PropTypes.string.isRequired,
};

/** DataLab's own status of the suitcase (center.status): ACTIVE, CREATED or DISABLED. */
export function CenterStatusBadge({ status }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });
  if (!status) {
    return null;
  }

  return (
    <span
      className={`${classes.badge} ${classes[`status_${status}`] || ''}`}
      title={t('centerStatus')}
    >
      {t(`centerStatus_${status}`, status)}
    </span>
  );
}

CenterStatusBadge.propTypes = {
  status: PropTypes.string,
};

CenterStatusBadge.defaultProps = {
  status: null,
};

/**
 * Date the suitcase became historic: the moment the active suitcase of its school started exporting
 * (a proxy until the centers hub provides the real date). Nothing for active suitcases.
 */
export function HistoricSinceBadge({ date }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });
  if (!date) {
    return null;
  }

  return (
    <span
      className={`${classes.badge} ${classes.since}`}
      title={t('historicSinceHint')}
    >
      {t('historicSince', { date })}
    </span>
  );
}

HistoricSinceBadge.propTypes = {
  date: PropTypes.string,
};

HistoricSinceBadge.defaultProps = {
  date: null,
};
